import { render, staticRenderFns } from "./CourierLimitMaster.vue?vue&type=template&id=76739bb8"
import script from "./CourierLimitMaster.vue?vue&type=script&lang=js"
export * from "./CourierLimitMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports